import DeliveryService from "../DeliveryService"

const Cms = {
    formData(data) {
        let form = new FormData()
        for (let obj in data) {
            form.append(obj, data[obj])
        }
        return form
    },
    createPoi(data) {
        const url = `/cms/poi`;
        return DeliveryService.post(url, data)
    },
    getPois() {
        const url = `/cms/pois`;
        return DeliveryService.get(url)
    },
    getPoiDetail(id) {
        const url = `/cms/poi/` + id;
        return DeliveryService.get(url)
    },
    editPoiInfo(data) {
        const url = `/cms/poi/info/` + data.id + `/edit`;
        return DeliveryService.post(url, data)
    },
    uploadPoiImage(data) {

        console.log(data)
        var block = data.file.split(";");
        var contentType = block[0].split(":")[1];
        var realData = block[1].split(",")[1];

        var blob = this.b64toBlob(realData, contentType);

        let formData = new FormData();
        formData.append("file", blob);


        const url = `/cms/poi/` + data.poi_id + `/upload`;
        return DeliveryService.post(url, formData)
    },
    getPosts() {
        const url = `/cms/posts`;
        return DeliveryService.get(url)
    },
    viewPost(slug) {
        const url = `/cms/posts/` + slug;
        return DeliveryService.get(url)
    },
    createPost(data) {
        const url = `/cms/posts`;
        return DeliveryService.post(url, data)
    },
    editPost(data) {
        const url = `/cms/posts/` + data.post_id + `/edit`;
        return DeliveryService.post(url, data)
    }
}
export default Cms